export const CONFIG_PERMISSIONS = {
  football: 1,
  tennis: 2,
  cricket: 4,
  baseball: 7511,
  basketball: 7522,
  greyhoundracing: 4339,
  horseracing: 7,
  live_casino: 8,
  indian_casino: 16,
  sports: 7,
  casino: 24,
  commission: 32,
};
